import { Stack } from "@mui/material";
import { GroupLegendInterface } from "../../../../Models/Common/List/LegendInterface";
import LegendItem from "./LegendItem";
import { GlobalConstants } from "../../../../Constants/GlobalConstants";
import { useLocation } from "react-router-dom";

const CustomLegend = (fieldProps: GroupLegendInterface) => {
    const location = useLocation()
    const { legends, ...props } = fieldProps;

    return <Stack
        key={location.pathname}
        direction={{ xs: 'column', sm: 'row' }}
        spacing={{ xs: 0.5 }}
        sx={{
            justifyContent: "flex-end",
            alignItems: "baseline",
            textTransform: "uppercase",
            alignContent: 'center'
        }}
        style={{ fontSize: GlobalConstants.LEGEND_FONT_SIZE }}>
        <div style={{marginRight: '10px', fontWeight: '500', alignSelf: 'center'}}>Legend : </div>
        {legends?.map((x) => {
            return <div onClick={() => props.onClickLegendItem(x.id)}>
                <LegendItem 
                color={x.color}
                title={x.title}
                count={x.count}
                id={x.id}
                paramName={props.paramName ?? 'status'}/>
            </div>
        })}
    </Stack>
}

export default CustomLegend;